/* Bomba il camion: a paintable cover of Milano Graffiti Magazine N°10. Lives in a shadow root so the theme's own CSS cannot change it. */
function gmStart(HOST) {
'use strict';
let CFG = {};
try { CFG = JSON.parse(HOST.querySelector('script[type="application/json"]').textContent); } catch (_) {}
const ROOT = HOST.attachShadow({ mode: 'open' });
ROOT.appendChild(HOST.querySelector('template').content.cloneNode(true));
const $ = (s, r = ROOT) => r.querySelector(s);
const $$ = (s, r = ROOT) => [...r.querySelectorAll(s)];
const W = 1080, H = 1350;
const COVER = CFG.cover;
// texts the page can change from Shopify (CFG.t, set in the section settings); an empty one falls back to these
const DEF = {
  sending: 'Invio in corso…', send: 'Mandami il mio camion',
  sent_title: 'Controlla la tua casella', sent_lead: 'Abbiamo mandato il tuo camion e il link al Magazine N°10 a {email}. Se non lo vedi, guarda anche nello spam.',
  ready_title: 'Il tuo camion è pronto', ready_lead: 'Salvalo, stampalo, mandacelo su Instagram.',
  fail_lead: 'L\'email non è partita. Puoi riprovare o salvare il camion qui sotto.',
  news_ok: 'Sei anche iscritto alla newsletter.', news_fail: 'L\'iscrizione alla newsletter non è andata a buon fine: riprova dal modulo in fondo al sito.',
  err_email: 'Controlla l\'indirizzo email: sembra incompleto.', err_privacy: 'Per continuare conferma di aver letto l\'informativa sulla privacy.'
};
const tx = k => (CFG.t && CFG.t[k]) || DEF[k];
const COLORS = [['Nero','#111111'],['Bianco','#ffffff'],['Argento','#b9bec7'],['Rosso','#e5262b'],['Arancio','#ff7a1a'],['Giallo','#ffd60a'],['Lime','#9be000'],['Verde','#12a150'],['Turchese','#00c2c7'],['Azzurro','#1c8cff'],['Blu','#1535d6'],['Viola','#7b2cff'],['Fucsia','#ff2d9a'],['Rosa','#ff9ecb']];
const CAP = { spray: [4, 8, 18, 36], pen: [2.5, 5, 10, 20], sticker: [40, 70, 130, 220], text: [34, 60, 110, 190] };
const SIZE_LABEL = { spray: 'Ugello', pen: 'Spessore', sticker: 'Dimensione', text: 'Dimensione' };
const ZMAX = 4;
const SHAPES = {
  star: (() => { let p = ''; for (let i = 0; i < 10; i++) { const a = -Math.PI / 2 + i * Math.PI / 5, r = i % 2 ? 20 : 48; p += (i ? 'L' : 'M') + (50 + Math.cos(a) * r).toFixed(1) + ' ' + (52 + Math.sin(a) * r).toFixed(1); } return p + 'Z'; })(),
  bolt: 'M58 2 L14 56 H42 L34 98 L86 40 H56 Z',
  heart: 'M50 92 C8 60 2 34 20 18 C34 6 50 16 50 28 C50 16 66 6 80 18 C98 34 92 60 50 92 Z',
  crown: 'M8 82 L8 28 L30 50 L50 12 L70 50 L92 28 L92 82 Z',
  arrow: 'M6 38 H58 V12 L96 50 L58 88 V62 H6 Z',
  flame: 'M50 3 C58 24 84 36 84 62 A34 34 0 0 1 16 62 C16 48 24 40 30 30 C34 40 40 46 43 46 C42 30 40 16 50 3 Z',
  drop: 'M50 4 C50 4 16 46 16 66 A34 34 0 0 0 84 66 C84 46 50 4 50 4 Z'
};
const S = { tool: 'spray', size: 2, color: '#111111', colorName: 'Nero', drips: true, sticker: 'star', outline: true, font: 'Permanent Marker', hand: false };
let step = 1;
let editing = false; // false: the cover is just shown; true: the visitor tapped it and can paint
let full = false; // full screen while painting

// ---------- image analysis: find the truck ----------
let CX = 0, CY = 0, CW = 0, CH = 0, LS = 2;
let layer, lx, outC, outBase, baseCrop, baseFull, maskCrop;
let ready = false;
const V = { z: 1, x: 0, y: 0 }; // zoom, and top-left of what is visible, in cover units (1080 x 1350)
// what the picture shows at zoom 1: the whole cover, or on a phone held sideways only the truck with a little margin
const BASE = { x: 0, y: 0, w: W, h: H, win: false };
const compactQ = window.matchMedia('(orientation: landscape) and (max-height: 600px)');

function dilate(src, w, h, r) {
  const t = new Uint8Array(w * h), o = new Uint8Array(w * h);
  for (let y = 0; y < h; y++) {
    const row = y * w;
    for (let x = 0; x < w; x++) if (src[row + x]) { const a = Math.max(0, x - r), b = Math.min(w - 1, x + r); for (let k = a; k <= b; k++) t[row + k] = 1; }
  }
  for (let x = 0; x < w; x++) {
    for (let y = 0; y < h; y++) if (t[y * w + x]) { const a = Math.max(0, y - r), b = Math.min(h - 1, y + r); for (let k = a; k <= b; k++) o[k * w + x] = 1; }
  }
  return o;
}

function prepare(img) {
  baseFull = document.createElement('canvas'); baseFull.width = W; baseFull.height = H;
  const fx = baseFull.getContext('2d', { willReadFrequently: true });
  fx.fillStyle = '#fff'; fx.fillRect(0, 0, W, H);
  fx.drawImage(img, 0, 0, W, H);
  const d = fx.getImageData(0, 0, W, H).data, N = W * H;
  const nonwhite = new Uint8Array(N);
  for (let i = 0; i < N; i++) { const o = i * 4; nonwhite[i] = (d[o] < 246 || d[o + 1] < 246 || d[o + 2] < 246) ? 1 : 0; }
  const barrier = dilate(nonwhite, W, H, 3);
  const outside = new Uint8Array(N), q = new Int32Array(N);
  let qh = 0, qt = 0;
  const push = i => { if (!barrier[i] && !outside[i]) { outside[i] = 1; q[qt++] = i; } };
  for (let x = 0; x < W; x++) { push(x); push((H - 1) * W + x); }
  for (let y = 0; y < H; y++) { push(y * W); push(y * W + W - 1); }
  while (qh < qt) { const i = q[qh++], x = i % W; if (x > 0) push(i - 1); if (x < W - 1) push(i + 1); if (i >= W) push(i - W); if (i < N - W) push(i + W); }
  const lab = new Int32Array(N);
  let best = 0, bestSize = 0, id = 0;
  for (let s = 0; s < N; s++) {
    if (outside[s] || lab[s]) continue;
    id++; let size = 0; qh = 0; qt = 0; lab[s] = id; q[qt++] = s;
    while (qh < qt) {
      const i = q[qh++], x = i % W; size++;
      const nb = [x > 0 ? i - 1 : -1, x < W - 1 ? i + 1 : -1, i >= W ? i - W : -1, i < N - W ? i + W : -1];
      for (const j of nb) if (j >= 0 && !outside[j] && !lab[j]) { lab[j] = id; q[qt++] = j; }
    }
    if (size > bestSize) { bestSize = size; best = id; }
  }
  const inv = new Uint8Array(N);
  for (let i = 0; i < N; i++) inv[i] = lab[i] === best ? 0 : 1;
  const grown = dilate(inv, W, H, 3);
  let x0 = W, y0 = H, x1 = 0, y1 = 0;
  const mask = new Uint8Array(N);
  for (let y = 0; y < H; y++) for (let x = 0; x < W; x++) { const i = y * W + x; if (!grown[i]) { mask[i] = 1; if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; } }
  const pad = 14;
  CX = Math.max(0, x0 - pad); CY = Math.max(0, y0 - pad);
  CW = Math.min(W, x1 + pad) - CX; CH = Math.min(H, y1 + pad) - CY;

  // the paint layer is stored at up to twice the size so it stays sharp when zoomed in
  LS = Math.max(1, Math.min(2, Math.sqrt(5.2e6 / (CW * CH))));
  const mk = (w, h) => { const c = document.createElement('canvas'); c.width = w; c.height = h; return c; };
  layer = mk(Math.round(CW * LS), Math.round(CH * LS)); lx = layer.getContext('2d');
  lx.setTransform(layer.width / CW, 0, 0, layer.height / CH, 0, 0);
  outC = mk(CW, CH);
  baseCrop = mk(CW, CH); baseCrop.getContext('2d').drawImage(baseFull, -CX, -CY);
  maskCrop = new Uint8Array(CW * CH);
  const od = new ImageData(CW, CH);
  for (let y = 0; y < CH; y++) for (let x = 0; x < CW; x++) {
    const gi = (y + CY) * W + (x + CX), ci = y * CW + x, o = gi * 4;
    if (mask[gi]) maskCrop[ci] = 1;
    else { const k = ci * 4; od.data[k] = od.data[k + 1] = od.data[k + 2] = 255; od.data[k + 3] = 255; } // white everywhere outside the truck hides stray paint
  }
  outC.getContext('2d').putImageData(od, 0, 0);
  outBase = mk(CW, CH); { const oc = outBase.getContext('2d'); oc.drawImage(baseFull, -CX, -CY); const bd = oc.getImageData(0, 0, CW, CH); for (let i = 0; i < maskCrop.length; i++) if (maskCrop[i]) bd.data[i * 4 + 3] = 0; oc.putImageData(bd, 0, 0); }
  view.style.aspectRatio = W + ' / ' + H;
  ready = true;
  fit();
}

// ---------- rendering ----------
const view = $('#view'), vx = view.getContext('2d');
let dirty = true;

function fit() {
  if (!ready) return;
  const w = view.clientWidth; if (!w) return;
  const dpr = Math.min(window.devicePixelRatio || 1, 2);
  const cw = Math.round(w * dpr), ch = Math.round(cw * BASE.h / BASE.w);
  if (view.width !== cw || view.height !== ch) { view.width = cw; view.height = ch; }
  dirty = true;
}
new ResizeObserver(fit).observe(view);

function clampV() {
  // never let a bad number (0 width while hidden, a division by zero...) leave the view somewhere impossible
  if (!isFinite(V.z) || V.z < 1) V.z = 1;
  if (V.z > ZMAX) V.z = ZMAX;
  if (!isFinite(V.x)) V.x = BASE.x;
  if (!isFinite(V.y)) V.y = BASE.y;
  const vw = BASE.w / V.z, vh = BASE.h / V.z;
  V.x = Math.min(Math.max(V.x, BASE.x), BASE.x + BASE.w - vw); V.y = Math.min(Math.max(V.y, BASE.y), BASE.y + BASE.h - vh);
}
// the visible part of the whole cover: white page, paint under the truck's line art (multiply), title and logo on top
function render() {
  const k = view.width * V.z / BASE.w;
  vx.setTransform(1, 0, 0, 1, 0, 0); vx.globalCompositeOperation = 'source-over';
  vx.fillStyle = '#fff'; vx.fillRect(0, 0, view.width, view.height);
  vx.setTransform(k, 0, 0, k, -V.x * k, -V.y * k);
  vx.imageSmoothingEnabled = true; vx.imageSmoothingQuality = 'high';
  if (overOn()) { vx.drawImage(baseFull, 0, 0, W, H); vx.drawImage(layer, CX, CY, CW, CH); vx.drawImage(outBase, CX, CY, CW, CH); }
  else {
  vx.drawImage(layer, CX, CY, CW, CH);
  vx.drawImage(outC, CX, CY, CW, CH);
  vx.globalCompositeOperation = 'multiply'; vx.drawImage(baseFull, 0, 0, W, H);
  vx.globalCompositeOperation = 'source-over';
  }
}
// the whole cover (truck + title + logo), sc = output pixels per cover pixel
function drawCover(x, sc) {
  x.setTransform(1, 0, 0, 1, 0, 0); x.globalCompositeOperation = 'source-over';
  x.fillStyle = '#fff'; x.fillRect(0, 0, Math.round(W * sc), Math.round(H * sc));
  x.setTransform(sc, 0, 0, sc, 0, 0); x.imageSmoothingEnabled = true; x.imageSmoothingQuality = 'high';
  if (overOn()) { x.drawImage(baseFull, 0, 0, W, H); x.drawImage(layer, CX, CY, CW, CH); x.drawImage(outBase, CX, CY, CW, CH); }
  else {
  x.drawImage(layer, CX, CY, CW, CH);
  x.drawImage(outC, CX, CY, CW, CH);
  x.globalCompositeOperation = 'multiply'; x.drawImage(baseFull, 0, 0, W, H);
  x.globalCompositeOperation = 'source-over';
  }
  x.setTransform(1, 0, 0, 1, 0, 0);
}
function renderCover(sc) {
  const c = document.createElement('canvas'); c.width = Math.round(W * sc); c.height = Math.round(H * sc);
  drawCover(c.getContext('2d'), sc); return c;
}

// ---------- undo ----------
const undoStack = [];
let undoMax = 14;
function pushUndo() {
  const c = document.createElement('canvas'); c.width = layer.width; c.height = layer.height;
  c.getContext('2d').drawImage(layer, 0, 0);
  undoStack.push(c); if (undoStack.length > undoMax) undoStack.shift();
  $('#undo').disabled = false;
}
function undo() {
  const c = undoStack.pop(); if (!c) return;
  drips.length = 0;
  lx.save(); lx.setTransform(1, 0, 0, 1, 0, 0); lx.clearRect(0, 0, layer.width, layer.height); lx.drawImage(c, 0, 0); lx.restore();
  dirty = true;
  $('#undo').disabled = !undoStack.length;
}

// ---------- paint helpers ----------
const hex = h => [parseInt(h.slice(1, 3), 16), parseInt(h.slice(3, 5), 16), parseInt(h.slice(5, 7), 16)];
const rgba = (h, a) => { const [r, g, b] = hex(h); return `rgba(${r},${g},${b},${a})`; };
const lum = h => { const [r, g, b] = hex(h); return 0.2126 * r + 0.7152 * g + 0.0722 * b; };
const outlineColor = () => lum(S.color) < 70 ? '#ffffff' : '#111111';

const drips = [];
function spray(x0, y0, x1, y1, dt, p) {
  const R = CAP.spray[S.size];
  const dist = Math.hypot(x1 - x0, y1 - y0);
  const steps = Math.min(14, Math.max(1, Math.ceil(dist / (R * 0.4))));
  const total = Math.round((R * R * 0.4 + 8) * (dt / 16.7));
  const per = Math.max(2, Math.round(total / steps));
  for (let s = 1; s <= steps; s++) {
    const px = x0 + (x1 - x0) * s / steps, py = y0 + (y1 - y0) * s / steps;
    const g = lx.createRadialGradient(px, py, 0, px, py, R);
    g.addColorStop(0, rgba(S.color, 0.09)); g.addColorStop(1, rgba(S.color, 0));
    lx.globalAlpha = 1; lx.fillStyle = g; lx.fillRect(px - R, py - R, R * 2, R * 2);
    lx.fillStyle = S.color;
    for (let k = 0; k < per; k++) {
      const a = Math.random() * 6.2832, r = R * Math.pow(Math.random(), 1.5);
      lx.globalAlpha = 0.5 + Math.random() * 0.45;
      lx.beginPath(); lx.arc(px + Math.cos(a) * r, py + Math.sin(a) * r, 0.4 + Math.random() * (0.5 + R / 24), 0, 6.2832); lx.fill();
    }
  }
  lx.globalAlpha = 1;
  if (S.drips) {
    if (dist < R * 0.5) p.wet += dt; else if (dist > R * 1.2) p.wet = Math.max(0, p.wet * 0.9);
    const limit = 720 - Math.min(R, 36) * 9;
    if (p.wet > limit) {
      p.wet = -250 - Math.random() * 350;
      drips.push({ x: x1 + (Math.random() - 0.5) * R * 0.9, y: y1 + R * 0.25, v: 0.8 + Math.random() * 0.9, w: Math.max(1.6, R * 0.15), len: 0, max: 40 + Math.random() * 40 + R * 4, color: S.color });
    }
  }
}
function updateDrips() {
  for (let i = drips.length - 1; i >= 0; i--) {
    const d = drips[i];
    lx.strokeStyle = d.color; lx.fillStyle = d.color; lx.lineWidth = d.w; lx.lineCap = 'round'; lx.globalAlpha = 1;
    lx.beginPath(); lx.moveTo(d.x, d.y); lx.lineTo(d.x, d.y + d.v); lx.stroke();
    d.y += d.v; d.len += d.v; d.v *= 0.993;
    if (d.len > d.max || d.v < 0.14) {
      lx.beginPath(); lx.arc(d.x, d.y, d.w * 0.8, 0, 6.2832); lx.fill();
      drips.splice(i, 1);
    }
  }
}
function penMove(p, x, y) {
  const w = CAP.pen[S.size], mx = (p.x + x) / 2, my = (p.y + y) / 2;
  lx.strokeStyle = S.color; lx.lineWidth = w; lx.lineCap = 'round'; lx.lineJoin = 'round'; lx.globalAlpha = 1;
  lx.beginPath(); lx.moveTo(p.mx, p.my); lx.quadraticCurveTo(p.x, p.y, mx, my); lx.stroke();
  p.mx = mx; p.my = my; p.x = x; p.y = y; dirty = true;
}
function placeSticker(x, y) {
  pushUndo();
  const size = CAP.sticker[S.size];
  lx.save(); lx.translate(x, y); lx.rotate((Math.random() * 24 - 12) * Math.PI / 180); lx.scale(size / 100, size / 100); lx.translate(-50, -50);
  const path = new Path2D(SHAPES[S.sticker]);
  lx.globalAlpha = 1; lx.fillStyle = S.color; lx.fill(path);
  if (S.outline) { lx.lineWidth = 6; lx.lineJoin = 'round'; lx.strokeStyle = outlineColor(); lx.stroke(path); }
  lx.restore(); dirty = true;
}
function placeText(x, y) {
  const val = ($('#textVal').value || '').trim(); if (!val) { toast('Scrivi qualcosa prima.'); return; }
  pushUndo();
  const size = CAP.text[S.size];
  lx.save(); lx.translate(x, y); lx.rotate(Number($('#rot').value) * Math.PI / 180);
  lx.font = `${size}px "${S.font}", Impact, sans-serif`; lx.textAlign = 'center'; lx.textBaseline = 'middle'; lx.lineJoin = 'round'; lx.globalAlpha = 1;
  if (S.outline) { lx.lineWidth = Math.max(4, size * 0.16); lx.strokeStyle = outlineColor(); lx.strokeText(val, 0, 0); }
  lx.fillStyle = S.color; lx.fillText(val, 0, 0);
  lx.restore(); dirty = true;
}
// ---------- zoom: the + and - buttons (smooth), two fingers (pinch and drag), Ctrl + wheel / trackpad pinch, and the hand ----------
const stageInner = $('#stageInner'), ring = $('#ring');
const rectOf = () => view.getBoundingClientRect();
const scaleOf = () => rectOf().width * V.z / BASE.w; // screen px per cover unit
// pointer position in truck units (the paint layer's own coordinates)
function pos(e) { const r = rectOf(), s = r.width * V.z / BASE.w; return [V.x + (e.clientX - r.left) / s - CX, V.y + (e.clientY - r.top) / s - CY]; }
// zoom the buttons are heading to (the animation may still be on its way)
const zTarget = () => zAnim ? zAnim.to : V.z;
function syncZoomUI() {
  const zt = zTarget();
  if (V.z <= 1.001 && zt <= 1.001) S.hand = false; // nothing to move when the whole cover is in view
  $('#zOut').disabled = zt <= 1.001; $('#zIn').disabled = zt >= ZMAX - 0.001;
  $('#handBtn').disabled = V.z <= 1.001 && zt <= 1.001;
  $('#handBtn').setAttribute('aria-pressed', String(S.hand));
  stageInner.classList.toggle('hand', S.hand);
  $('#handNote').hidden = !(S.hand && editing && step === 1);
}
// zooms to nz and keeps the point of the cover that sits at (fx, fy) (0..1 of the visible area) exactly where it is on screen
function zoomKeep(nz, fx, fy) {
  nz = Math.min(ZMAX, Math.max(1, nz)); if (!isFinite(nz)) return;
  const ax = V.x + fx * BASE.w / V.z, ay = V.y + fy * BASE.h / V.z;
  V.z = nz; V.x = ax - fx * BASE.w / nz; V.y = ay - fy * BASE.h / nz;
  clampV(); dirty = true;
}
// the + and - buttons, the keys: a short ease towards the new zoom around the centre of what is visible; quick taps add up
let zAnim = null;
function zoomStop() { zAnim = null; }
function zoomBy(f) {
  const to = Math.min(ZMAX, Math.max(1, zTarget() * f));
  if (reduceMotion()) { zAnim = null; zoomKeep(to, 0.5, 0.5); syncZoomUI(); return; }
  zAnim = { from: V.z, to, t0: performance.now(), dur: 190 };
  syncZoomUI();
}
function zoomAnimStep(now) {
  if (!zAnim) return;
  const u = Math.min(1, Math.max(0, (now - zAnim.t0) / zAnim.dur)), e = 1 - Math.pow(1 - u, 3);
  zoomKeep(zAnim.from * Math.pow(zAnim.to / zAnim.from, e), 0.5, 0.5);
  if (u >= 1) { zAnim = null; syncZoomUI(); }
}
function zoomFit() { zoomStop(); V.z = 1; V.x = BASE.x; V.y = BASE.y; dirty = true; syncZoomUI(); }
// switches between the whole cover and the truck-only view (phone on its side, while painting)
function applyBase(force) {
  if (!ready) return;
  const win = (compactQ.matches || full) && editing && step === 1;
  if (win === BASE.win && !force) return;
  // turning the phone or going full screen while painting: keep looking at the same part of the truck, as far as the new frame allows
  const keep = BASE.win !== undefined && editing && step === 1 && V.z > 1.001;
  const cx = V.x + BASE.w / V.z / 2, cy = V.y + BASE.h / V.z / 2, visW = BASE.w / V.z;
  const m = 26;
  if (win) { BASE.x = Math.max(0, CX - m); BASE.y = Math.max(0, CY - m); BASE.w = Math.min(W, CX + CW + m) - BASE.x; BASE.h = Math.min(H, CY + CH + m) - BASE.y; }
  else { BASE.x = 0; BASE.y = 0; BASE.w = W; BASE.h = H; }
  if (win && full && OPT.fsArea) { const a = fitAspect(); if (a) { const bx = BASE.x, by = BASE.y, bw = BASE.w, bh = BASE.h, w2 = Math.max(bw, bh * a), h2 = w2 / a; BASE.x = bx + bw / 2 - w2 / 2; BASE.y = by + bh / 2 - h2 / 2; BASE.w = w2; BASE.h = h2; } }
  BASE.win = win;
  view.style.aspectRatio = BASE.w + ' / ' + BASE.h;
  $('#gameSection').style.setProperty('--ar', (BASE.w / BASE.h).toFixed(4));
  $('.game').dataset.base = win ? 'window' : 'cover';
  zoomStop(); endInteraction();
  if (keep && isFinite(cx + cy + visW)) {
    V.z = Math.min(ZMAX, Math.max(1, BASE.w / visW));
    V.x = cx - BASE.w / V.z / 2; V.y = cy - BASE.h / V.z / 2; clampV();
  } else { S.hand = false; V.z = 1; V.x = BASE.x; V.y = BASE.y; }
  dirty = true; syncZoomUI();
  requestAnimationFrame(() => { fit(); dirty = true; });
}
// choosing a tool, colour or size always means "paint": it switches the hand off
function paintMode() { if (S.hand) { S.hand = false; endInteraction(); syncZoomUI(); } }
onTap($('#zIn'), () => zoomBy(1.5));
onTap($('#zOut'), () => zoomBy(1 / 1.5));
onTap($('#handBtn'), () => { if (V.z <= 1.001) return; S.hand = !S.hand; endInteraction(); syncZoomUI(); });

// ---------- pointer input ----------
// one finger (or the mouse) paints, or moves the cover when the hand is on; two fingers pinch and drag the cover, whatever tool is selected.
// Every new touch starts from a clean state.
let ptr = null, pan = null, activeId = null, pinch = null, zFlags = 0;
const pts = new Map(); // the fingers (or pen) now touching the picture: pointer id -> {x, y}
function endStroke() { ptr = null; pan = null; activeId = null; stageInner.classList.remove('panning'); ring.hidden = true; }
function endInteraction() { endStroke(); pts.clear(); pinch = null; }
function updateRing(e) {
  const t = S.tool;
  if (!editing || step !== 1 || e.pointerType !== 'mouse' || S.hand || !(t === 'spray' || t === 'pen')) { ring.hidden = true; return; }
  const s = scaleOf();
  const rad = t === 'spray' ? CAP.spray[S.size] : CAP.pen[S.size] / 2;
  const sr = stageInner.getBoundingClientRect();
  ring.style.width = ring.style.height = Math.max(6, rad * 2 * s) + 'px';
  ring.style.left = (e.clientX - sr.left) + 'px'; ring.style.top = (e.clientY - sr.top) + 'px';
  ring.hidden = false;
}
// the second finger lands: whatever the first one had started is dropped (a stroke that is only a few moments old is taken back, so no stray dot stays)
function startPinch() {
  if (ptr && (ptr.type === 'spray' || ptr.type === 'pen') && performance.now() - ptr.t0 < 400) undo();
  endStroke(); zoomStop();
  const [a, b] = [...pts.values()], r = rectOf();
  const mx = (a.x + b.x) / 2, my = (a.y + b.y) / 2;
  pinch = { d0: Math.max(24, Math.hypot(a.x - b.x, a.y - b.y)), z0: V.z, ax: V.x + (mx - r.left) / r.width * BASE.w / V.z, ay: V.y + (my - r.top) / r.height * BASE.h / V.z };
  stageInner.classList.add('panning'); syncZoomUI();
}
// the point of the cover that was between the fingers stays between the fingers: zoom and drag in one gesture
function pinchMove() {
  if (!pinch || pts.size < 2) return;
  const [a, b] = [...pts.values()], r = rectOf();
  if (!r.width || !r.height) return;
  const d = Math.hypot(a.x - b.x, a.y - b.y), mx = (a.x + b.x) / 2, my = (a.y + b.y) / 2;
  const nz = Math.min(ZMAX, Math.max(1, pinch.z0 * d / pinch.d0));
  V.z = nz; V.x = pinch.ax - (mx - r.left) / r.width * BASE.w / nz; V.y = pinch.ay - (my - r.top) / r.height * BASE.h / nz;
  clampV(); dirty = true;
  const f = (V.z <= 1.001 ? 1 : 0) + (V.z >= ZMAX - 0.001 ? 2 : 0);
  if (f !== zFlags) { zFlags = f; syncZoomUI(); }
}
view.addEventListener('pointerdown', e => {
  if (!ready || step !== 1 || !editing) return;
  if (e.pointerType === 'mouse' && (e.button !== 0 || !e.isPrimary)) return;
  e.preventDefault();
  if (e.pointerType !== 'mouse') {
    if (e.isPrimary) { pts.clear(); pinch = null; } // a first finger: anything left over from before is gone
    if (pts.size >= 2 && !pts.has(e.pointerId)) return; // a third finger is ignored
    pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
    try { view.setPointerCapture(e.pointerId); } catch (_) {}
    if (pts.size === 2) startPinch();
    if (pts.size >= 2) return;
  } else { try { view.setPointerCapture(e.pointerId); } catch (_) {} }
  endStroke(); zoomStop(); activeId = e.pointerId;
  if (S.hand) { pan = { sx: e.clientX, sy: e.clientY, x: V.x, y: V.y }; stageInner.classList.add('panning'); return; }
  updateRing(e);
  const [x, y] = pos(e); if (fxRaf) fxStop();
  if (S.tool === 'spray') { pushUndo(); ptr = { type: 'spray', x, y, tx: x, ty: y, wet: 0, t0: performance.now() }; }
  else if (S.tool === 'pen') { pushUndo(); ptr = { type: 'pen', x, y, mx: x, my: y, t0: performance.now() }; penMove(ptr, x + 0.01, y); }
  else ptr = { type: 'tap', tool: S.tool }; // stickers and text land where the finger lifts, so a second finger can still turn the touch into a pinch
});
view.addEventListener('pointermove', e => {
  updateRing(e);
  if (pts.has(e.pointerId)) { pts.set(e.pointerId, { x: e.clientX, y: e.clientY }); if (pinch) { pinchMove(); return; } }
  if (e.pointerId !== activeId) return;
  if (e.pointerType === 'mouse' && e.buttons === 0) { endStroke(); return; } // the button was released outside the page
  if (pan) { const s = scaleOf(); if (!(s > 0)) return; V.x = pan.x - (e.clientX - pan.sx) / s; V.y = pan.y - (e.clientY - pan.sy) / s; clampV(); dirty = true; return; }
  if (!ptr) return;
  const [x, y] = pos(e);
  if (ptr.type === 'spray') { ptr.tx = x; ptr.ty = y; } else if (ptr.type === 'pen') penMove(ptr, x, y);
});
function endPtr(e) {
  pts.delete(e.pointerId);
  if (pinch && pts.size < 2) { pinch = null; stageInner.classList.remove('panning'); syncZoomUI(); } // a finger that stays down does nothing until it is lifted
  if (e.pointerId !== activeId) return;
  if (ptr && ptr.type === 'tap' && e.type === 'pointerup') {
    const [x, y] = pos(e), tool = ptr.tool; endStroke();
    if (tool === 'sticker') placeSticker(x, y); else if (tool === 'text') placeText(x, y);
    return;
  }
  endStroke();
}
['pointerup', 'pointercancel', 'lostpointercapture'].forEach(n => view.addEventListener(n, endPtr));
window.addEventListener('pointerup', endPtr); window.addEventListener('pointercancel', endPtr);
window.addEventListener('blur', endInteraction);
document.addEventListener('visibilitychange', () => { if (document.hidden) endInteraction(); });
view.addEventListener('pointerleave', () => { ring.hidden = true; });
// Ctrl + wheel and the trackpad pinch (desktop): zoom around the pointer instead of zooming the whole page
view.addEventListener('wheel', e => {
  if (!e.ctrlKey || !editing || step !== 1 || !ready) return;
  e.preventDefault(); zoomStop();
  const r = rectOf(); if (!r.width || !r.height) return;
  zoomKeep(V.z * Math.exp(-e.deltaY * (e.deltaMode === 1 ? 0.05 : 0.0025)), (e.clientX - r.left) / r.width, (e.clientY - r.top) / r.height);
  syncZoomUI();
}, { passive: false });
// Safari: its own pinch gesture would zoom the whole page (and a double tap would too); while painting it zooms the picture instead, or does nothing
let gz = 1;
const painting = () => editing && step === 1 && ready;
ROOT.addEventListener('gesturestart', e => { if (!painting()) return; e.preventDefault(); gz = V.z; zoomStop(); });
ROOT.addEventListener('gesturechange', e => {
  if (!painting()) return; e.preventDefault();
  if (pts.size || !(e.composedPath && e.composedPath()[0] === view) || !isFinite(e.clientX)) return; // on a touch screen the two fingers are already handled above
  const r = rectOf(); if (!r.width || !r.height) return;
  zoomKeep(gz * e.scale, (e.clientX - r.left) / r.width, (e.clientY - r.top) / r.height); syncZoomUI();
});
ROOT.addEventListener('gestureend', e => { if (painting()) e.preventDefault(); });

let last = performance.now();
function frame(t) {
  requestAnimationFrame(frame); // first, so that one failed frame can never stop the game
  const dt = Math.min(50, t - last); last = t;
  if (!ready) return;
  try {
    if (zAnim) zoomAnimStep(t);
    if (ptr && ptr.type === 'spray') { spray(ptr.x, ptr.y, ptr.tx, ptr.ty, dt, ptr); ptr.x = ptr.tx; ptr.y = ptr.ty; dirty = true; }
    if (drips.length) { updateDrips(); dirty = true; }
    if (dirty && step === 1) { render(); dirty = false; }
  } catch (err) { dirty = false; if (!frame.warned) { frame.warned = true; try { console.error('[camion]', err); } catch (_) {} } }
}

// ---------- UI wiring ----------
// the banner exists only on the cover: touching the cover makes it go away for good
function syncHint() { $('#hint').hidden = !(step === 1 && !editing); }
let toastT;
function toast(msg) { const t = $('#toast'); t.textContent = msg; t.hidden = false; clearTimeout(toastT); toastT = setTimeout(() => { t.hidden = true; }, 2200); }
// touch: act on release; mouse and keyboard: act on click (a click that follows a handled release is ignored).
// Only for controls that do not move the layout, so the click that follows can never land on something else.
function onTap(el, fn) {
  let at = 0;
  el.addEventListener('pointerup', e => {
    if (e.pointerType === 'mouse' || el.disabled) return;
    const r = el.getBoundingClientRect();
    if (e.clientX < r.left - 8 || e.clientX > r.right + 8 || e.clientY < r.top - 8 || e.clientY > r.bottom + 8) return;
    at = Date.now(); fn(e);
  });
  el.addEventListener('click', e => { if (Date.now() - at < 800) return; fn(e); });
}
const press = (els, on) => els.forEach(b => b.setAttribute('aria-pressed', String(on(b))));

function syncTool() {
  const t = S.tool;
  press($$('#tools .tool'), b => b.dataset.tool === t);
  $('#optSpray').hidden = t !== 'spray';
  $('#optSticker').hidden = t !== 'sticker';
  $('#optText').hidden = t !== 'text';
  $('#optOutline').hidden = !(t === 'sticker' || t === 'text');
  if (SIZE_LABEL[t]) $('#sizeLabel').textContent = SIZE_LABEL[t];
  ring.hidden = true; syncTab();
}
$('#tools').addEventListener('click', e => { const b = e.target.closest('.tool'); if (!b) return; S.tool = b.dataset.tool; S.hand = false; syncTool(); syncZoomUI(); });
$('#sizes').addEventListener('click', e => { const b = e.target.closest('button'); if (!b) return; S.size = Number(b.dataset.size); press($$('#sizes button'), x => x === b); paintMode(); });
$('#dripToggle').addEventListener('click', e => { S.drips = !S.drips; e.currentTarget.setAttribute('aria-pressed', String(S.drips)); });
$('#outlineToggle').addEventListener('click', e => { S.outline = !S.outline; e.currentTarget.setAttribute('aria-pressed', String(S.outline)); });
$('#fonts').addEventListener('click', e => { const b = e.target.closest('button'); if (!b) return; S.font = b.dataset.font; press($$('#fonts button'), x => x === b); paintMode(); });

const colorsEl = $('#colors');
COLORS.forEach(([name, c]) => {
  const b = document.createElement('button');
  b.type = 'button'; b.className = 'sw'; b.style.setProperty('--c', c); b.setAttribute('aria-label', name); b.dataset.c = c; b.dataset.n = name;
  b.setAttribute('aria-pressed', String(c === S.color));
  colorsEl.appendChild(b);
});
colorsEl.addEventListener('click', e => {
  const b = e.target.closest('.sw'); if (!b) return;
  S.color = b.dataset.c; S.colorName = b.dataset.n; $('#colorName').textContent = S.colorName;
  press($$('.sw', colorsEl), x => x === b); syncTab(); paintMode();
});
const shapesEl = $('#shapes');
Object.entries(SHAPES).forEach(([k, d]) => {
  const b = document.createElement('button');
  b.type = 'button'; b.dataset.shape = k; b.setAttribute('aria-label', 'Forma ' + k); b.setAttribute('aria-pressed', String(k === S.sticker));
  b.innerHTML = `<svg viewBox="0 0 100 100" aria-hidden="true"><path d="${d}" fill="currentColor"/></svg>`;
  shapesEl.appendChild(b);
});
shapesEl.addEventListener('click', e => { const b = e.target.closest('button'); if (!b) return; S.sticker = b.dataset.shape; press($$('button', shapesEl), x => x === b); paintMode(); });
onTap($('#undo'), undo);
onTap($('#clear'), () => { if (!ready) return; pushUndo(); drips.length = 0; lx.clearRect(0, 0, CW, CH); dirty = true; });

const typing = t => t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.tagName === 'SELECT' || t.isContentEditable);
window.addEventListener('keydown', e => {
  if (typing(e.composedPath ? e.composedPath()[0] : e.target) || step !== 1 || !editing) return;
  if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'z') { e.preventDefault(); undo(); return; }
  if (e.ctrlKey || e.metaKey || e.altKey) return;
  if (e.key === '+' || e.key === '=') zoomBy(1.5);
  else if (e.key === '-' || e.key === '_') zoomBy(1 / 1.5);
  else if (e.key === 'Escape') { if (full) setFull(false); else setEditing(false); }
});

// ---------- tools tab (closed by default) ----------
const gameEl = $('.game'), drawer = $('#drawer'), drawerIn = $('#drawerIn'), tabBtn = $('#tabBtn');
function setTools(open) {
  gameEl.dataset.open = String(open); drawer.dataset.open = String(open);
  tabBtn.setAttribute('aria-expanded', String(open)); drawerIn.inert = !open;
  requestAnimationFrame(() => { fit(); dirty = true; });
}
tabBtn.addEventListener('click', () => setTools(drawer.dataset.open !== 'true'));
const TOOL_NAME = { spray: 'Spray', pen: 'Marker', sticker: 'Adesivi', text: 'Scritta' };
function syncTab() {
  $('#tabDot').style.setProperty('--c', S.color);
  $('#tabSub').textContent = TOOL_NAME[S.tool] + ' · ' + S.colorName;
}

// ---------- motion: when the visitor taps the cover the truck lights up twice in the paint colour and the logo shows up with it ----------
const fxCv = $('#fx'), fxc = fxCv.getContext('2d');
let fxRaf = 0;
const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const easeOut = t => 1 - Math.pow(1 - t, 3);
const smooth = (t, a, b) => { const u = Math.min(1, Math.max(0, (t - a) / (b - a))); return u * u * (3 - 2 * u); };
const ART = new Image(); ART.src = window.GM_ART || '';
const ART_M = new Image(); ART_M.src = window.GM_ART_M || '';
const ART_BOX_M = { x: 50.5, y: 616.1, w: 978.8, h: 154.2 }; // metro: graffiti GRAFFITI | MILANO laid out on the strip, in cover units (from Leonardo's layout)
const ART_BOX = { x: 343, y: 442, w: 645, h: 355 }; // where the artwork sits on the side of the cargo box, in cover units (from the reference cover)
function fxStop() {
  cancelAnimationFrame(fxRaf); fxRaf = 0;
  fxc.setTransform(1, 0, 0, 1, 0, 0); fxc.clearRect(0, 0, fxCv.width, fxCv.height);
}
function fxRun(ms, draw) {
  const t0 = performance.now();
  const step = now => {
    const t = Math.min(1, (now - t0) / ms);
    fxc.setTransform(1, 0, 0, 1, 0, 0); fxc.clearRect(0, 0, fxCv.width, fxCv.height);
    draw(t);
    if (t < 1) fxRaf = requestAnimationFrame(step); else fxStop();
  };
  fxRaf = requestAnimationFrame(step);
}
// the truck's shape in one colour (to light it up)
function silhouette(color) {
  const c = document.createElement('canvas'); c.width = CW; c.height = CH;
  const x = c.getContext('2d'), id = new ImageData(CW, CH);
  for (let i = 0; i < maskCrop.length; i++) if (maskCrop[i]) id.data[i * 4 + 3] = 255;
  x.putImageData(id, 0, 0); x.globalCompositeOperation = 'source-in'; x.fillStyle = color; x.fillRect(0, 0, CW, CH);
  return c;
}
function startMotion() {
  fxStop(); if (reduceMotion() || !ready || !view.clientWidth) return;
  const dpr = Math.min(window.devicePixelRatio || 1, 2);
  fxCv.width = Math.round(view.clientWidth * dpr); fxCv.height = Math.round(view.clientHeight * dpr);
  const MT = scene === 'metro', AX = MT ? ART_M : ART, BX = MT ? ART_BOX_M : ART_BOX;
  const FW = fxCv.width, sil = silhouette(S.color), ok = AX.naturalWidth > 0;
  const acx = BX.x + BX.w / 2, acy = BX.y + BX.h / 2;
  fxRun(1900, t => {
    const k = FW * V.z / BASE.w;
    fxc.setTransform(k, 0, 0, k, -V.x * k, -V.y * k); fxc.imageSmoothingEnabled = true; fxc.imageSmoothingQuality = 'high';
    const beat = 0.5 - 0.5 * Math.cos(t * Math.PI * 4); // two beats
    const env = smooth(t, 0, .1) * (1 - smooth(t, .8, 1));
    fxc.globalAlpha = env * (0.30 + 0.30 * beat);
    fxc.drawImage(sil, CX, CY, CW, CH);
    if (ok) {
      const pop = 0.88 + 0.12 * easeOut(Math.min(1, Math.max(0, (t - .05) / .18))), sc = pop * (1 + 0.03 * beat);
      fxc.globalAlpha = smooth(t, .05, .17) * (1 - smooth(t, .8, .97));
      fxc.drawImage(AX, acx - BX.w * sc / 2, acy - BX.h * sc / 2, BX.w * sc, BX.h * sc);
    }
    fxc.globalAlpha = 1;
  });
}

// ---------- the cover comes first; tapping it opens the painting tools ----------
function syncMode() {
  const on = step === 1 && editing;
  gameEl.dataset.mode = editing ? 'edit' : 'cover';
  { const q = $('#sceneAsk'); if (q && editing) q.hidden = true; }
  $('#armOverlay').hidden = !(step === 1 && !editing);
  $('#coverFoot').hidden = !(step === 1 && !editing);
  $('#closeBtn').hidden = !on;
  $('#stageBar').hidden = !on; $('#dock').hidden = !on; drawer.hidden = !on;
  syncHint(); syncZoomUI();
}
// brings the cover and its controls into view without hiding the top of the cover
function revealTools() {
  requestAnimationFrame(() => {
    if (compactQ.matches) { window.scrollBy({ top: gameEl.getBoundingClientRect().top - 6, behavior: 'smooth' }); return; } // phone on its side: the truck fills the screen
    const bottom = Math.max($('#dock').getBoundingClientRect().bottom, $('#stageBar').getBoundingClientRect().bottom);
    const top = stageInner.getBoundingClientRect().top;
    const over = bottom - (window.innerHeight - 46);
    if (over > 0) window.scrollBy({ top: Math.min(over, Math.max(0, top - 8)), behavior: 'smooth' });
  });
}
function setEditing(v, opts = {}) {
  if (editing === v) return;
  editing = v; endInteraction();
  if (v) {
    syncMode(); applyBase();
    if (compactQ.matches) setTools(true); // on its side the tools sit next to the truck, always open
    if (opts.reveal !== false) revealTools();
    startMotion();
  } else {
    if (full) setFull(false);
    fxStop(); S.hand = false; setTools(false); syncMode(); applyBase(); zoomFit();
  }
  requestAnimationFrame(() => { fit(); dirty = true; });
}
// turning the phone while painting: the view and the tools rearrange, the painting stays
compactQ.addEventListener('change', () => {
  applyBase();
  if (editing && step === 1) { if (compactQ.matches) setTools(true); revealTools(); }
});
$('#armOverlay').addEventListener('click', e => { if (ready) setEditing(true); });
$('#closeBtn').addEventListener('click', () => { if (full) setFull(false); else setEditing(false); });


// ---------- full screen: the whole window is the sheet, the truck uses the full width and the tools sit in a strip below ----------
// Tries the browser's own full screen (hides the address bar too; not available on iPhone Safari) and always covers the whole page.
const fullBtn = $('#fullBtn'), finishBtn = $('#finish'), finishHome = finishBtn.parentNode;
let toolsBeforeFull = false, park = null, scrollBeforeFull = 0;
const canFullQ = matchMedia('(hover: hover) and (pointer: fine)'); // full screen is offered on computers with a mouse only, not on phones or tablets
function setFull(v, native = true) {
  if (v === full) return;
  if (v && !(editing && step === 1 && canFullQ.matches)) return;
  if (v) scrollBeforeFull = window.scrollY || window.pageYOffset || 0;
  full = v; gameEl.dataset.full = String(v);
  document.documentElement.classList.toggle('gm-lock', v);
  if (v) { park = document.createComment('gm'); HOST.parentNode.insertBefore(park, HOST); document.body.appendChild(HOST); }
  else if (park && park.parentNode) { park.parentNode.replaceChild(HOST, park); park = null; window.scrollTo(0, scrollBeforeFull); } // back to the same place on the page
  endInteraction(); S.hand = false;
  if (v) {
    toolsBeforeFull = drawer.dataset.open === 'true';
    $('#stageBar').insertBefore(finishBtn, $('#closeBtn')); // the "I'm done" button joins the top bar
    setTools(true);
    const de = document.documentElement, rq = de.requestFullscreen || de.webkitRequestFullscreen;
    if (native && rq) { try { const r = rq.call(de); if (r && r.catch) r.catch(() => {}); } catch (_) {} }
  } else {
    finishHome.appendChild(finishBtn);
    const fs = document.fullscreenElement || document.webkitFullscreenElement;
    if (fs) { try { (document.exitFullscreen || document.webkitExitFullscreen).call(document); } catch (_) {} }
    if (!compactQ.matches) setTools(toolsBeforeFull);
  }
  applyBase(); syncZoomUI(); // the part of the truck being looked at stays (applyBase keeps it)
  requestAnimationFrame(() => { fit(); dirty = true; });
}
fullBtn.addEventListener('click', () => setFull(true));
document.addEventListener('fullscreenchange', () => { if (full && !document.fullscreenElement) setFull(false, false); });
document.addEventListener('webkitfullscreenchange', () => { if (full && !document.webkitFullscreenElement) setFull(false, false); });

// ---------- step 2: receive ----------
let coverURL = '';
function goStep(n, quiet) {
  if (n !== 1 && full) setFull(false);
  step = n; $('.game').dataset.step = String(n);
  $('#sendPanel').hidden = n !== 2;
  view.hidden = n !== 1; $('#coverPrev').hidden = n !== 2;
  endInteraction(); syncMode(); applyBase();
  if (n === 2) {
    drips.length = 0;
    coverURL = renderCover(1).toDataURL('image/png');
    $('#coverPrev').src = coverURL;
    $('#sendForm').hidden = false; $('#sentView').hidden = true; $('#formErr').hidden = true;
    if (!quiet) gameEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
  } else { requestAnimationFrame(() => { fit(); dirty = true; }); }
}
$('#finish').addEventListener('click', () => ready && goStep(2));
$('#backBtn').addEventListener('click', () => goStep(1));
$('#againBtn').addEventListener('click', () => { goStep(1); });
// one screen: the finished truck stays where it is, only the panel beside it changes.
// mailed = the e-mail went out; failed = the service answered with an error; neither = no e-mail service is connected yet (the visitor can save the picture instead)
function showSent(email, mailed, failed, news, newsFailed, quiet) {
  $('#sendForm').hidden = true; $('#sentView').hidden = false;
  $('#sentTitle').textContent = mailed ? tx('sent_title') : tx('ready_title');
  let t = mailed ? tx('sent_lead').split('{email}').join(email) : failed ? tx('fail_lead') : tx('ready_lead');
  if (news) t += ' ' + (newsFailed ? tx('news_fail') : tx('news_ok'));
  $('#sentLead').textContent = t;
  $('#saveRow').hidden = mailed; $('#mailMag').hidden = mailed; $('#retryBtn').hidden = !failed;
  if (!quiet) $('#sendPanel').scrollIntoView({ behavior: 'smooth', block: 'start' });
}
$('#retryBtn').addEventListener('click', () => { $('#sentView').hidden = true; $('#sendForm').hidden = false; $('#formErr').hidden = true; });
// optional newsletter: the same Shopify customer form the site's newsletter uses
function subscribeNews(email) {
  const body = new URLSearchParams({ form_type: 'customer', utf8: '✓', 'contact[email]': email, 'contact[tags]': 'newsletter,gioco-bomba-il-camion' });
  return fetch(CFG.newsUrl || '/contact', { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body, credentials: 'same-origin' }).then(r => r.ok && !/\/challenge/.test(r.url)).catch(() => false);
}
const blobURL = (cv, type, q) => new Promise(res => cv.toBlob(b => { const fr = new FileReader(); fr.onload = () => res(fr.result); fr.readAsDataURL(b); }, type, q));
$('#mailForm').addEventListener('submit', async e => {
  e.preventDefault();
  const email = $('#email').value.trim(), err = $('#formErr');
  const showErr = m => { err.textContent = m; err.hidden = false; };
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) return showErr(tx('err_email'));
  if (!$('#cPriv').checked) return showErr(tx('err_privacy'));
  err.hidden = true;
  const btn = $('#sendBtn'), sendLabel = btn.textContent; btn.disabled = true; btn.textContent = tx('sending');
  const news = $('#cNews').checked;
  const newsP = news ? subscribeNews(email) : Promise.resolve(true);
  let mailed = false;
  if (CFG.endpoint) {
    try {
      const image = await blobURL(renderCover(2), 'image/jpeg', 0.9);
      // sent as plain text on purpose: a "simple" request needs no CORS preflight, so Google Apps Script and any other small service can answer it
      const res = await fetch(CFG.endpoint, { method: 'POST', headers: { 'Content-Type': 'text/plain;charset=utf-8' }, body: JSON.stringify({ email, news, privacy: true, image, page: location.href, scene }) });
      const data = await res.json().catch(() => null);
      mailed = !!(res.ok && data && data.ok === true); // the service answers {"ok":true}
    } catch (_) { mailed = false; }
  }
  const newsOk = await newsP;
  btn.disabled = false; btn.textContent = sendLabel;
  showSent(email, mailed, !!CFG.endpoint && !mailed, news, !newsOk);
});

// downloads
const toBlob = c => new Promise(res => c.toBlob(res, 'image/png'));
async function save(name, canvas) {
  const blob = await toBlob(canvas);
  if (!blob) return toast('Non riesco a salvare.');
  const u = URL.createObjectURL(blob), a = document.createElement('a');
  a.href = u; a.download = name; a.rel = 'noopener'; document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(u), 60000);
}
$('#savePng').addEventListener('click', () => save(scene === 'metro' ? 'bomba-la-metro-graffiti-milano.png' : 'bomba-il-camion-graffiti-milano.png', renderCover(2)));


// ===== Camion / Metro: scelta della scena, vernice sopra la metro, cornice a tutto schermo =====
const OPT = { over: true, fsArea: true };
const overOn = () => OPT.over && scene === 'metro';
function fitAspect() { const f = $('#stageFit'); if (!f) return 0; const cs = getComputedStyle(f); const w = f.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight), h = f.clientHeight - parseFloat(cs.paddingTop) - parseFloat(cs.paddingBottom); return (w > 50 && h > 50) ? w / h : 0; }
if (window.ResizeObserver) new ResizeObserver(() => { if (full && OPT.fsArea && editing && step === 1) applyBase(true); }).observe($('#stageFit'));
const SCENES = CFG.scenes || {};
if (SCENES.metro) SCENES.metro.cover = SCENES.metro.cover || window.GM_COVER_M || '';
if (SCENES.truck) SCENES.truck.cover = SCENES.truck.cover || COVER;
const SCENES_OK = CFG.scenesOn !== false && !!(SCENES.metro && SCENES.metro.cover && SCENES.truck && SCENES.truck.cover);
{ const sg = $('#sceneSeg'), ob = $('#otherBtn'); if (sg) sg.hidden = !SCENES_OK; if (ob) ob.hidden = !SCENES_OK; }
const T0 = Object.assign({}, CFG.t || {});
const TMETRO = { send: 'Mandami la mia metro', sent_lead: 'Abbiamo mandato la tua metro e il link al Magazine N°10 a {email}. Se non lo vedi, guarda anche nello spam.', ready_title: 'La tua metro è pronta', fail_lead: 'L’email non è partita. Puoi riprovare o salvare la metro qui sotto.' };
const RELABEL = [['Tocca il camion', 'Tocca la metro'], ['Ricevi il tuo camion', 'Ricevi la tua metro'], ['ti mandiamo il tuo camion', 'ti mandiamo la tua metro'], ['inviarmi il camion', 'inviarmi la metro'], ['Mandami il mio camion', 'Mandami la mia metro'], ['Il tuo camion è pronto', 'La tua metro è pronta'], ['con il camion da dipingere', 'con la metro da dipingere'], ['Dipingi un altro camion', 'Dipingi un’altra metro'], ['Dipingi il camion', 'Dipingi la metro']];
const ORIG = new Map();
let scene = 'truck', pendingScene = null;
const toMetro = s => RELABEL.reduce((t, p) => t.split(p[0]).join(p[1]), s);
function relabel() {
  const w = document.createTreeWalker(ROOT, NodeFilter.SHOW_TEXT); let n;
  while ((n = w.nextNode())) {
    if (!ORIG.has(n)) { if (!/camion/i.test(n.nodeValue)) continue; ORIG.set(n, n.nodeValue); }
    n.nodeValue = scene === 'metro' ? toMetro(ORIG.get(n)) : ORIG.get(n);
  }
  $$('[aria-label]').forEach(e => {
    if (!e.dataset.al) { if (!/camion/i.test(e.getAttribute('aria-label'))) return; e.dataset.al = e.getAttribute('aria-label'); }
    e.setAttribute('aria-label', scene === 'metro' ? toMetro(e.dataset.al) : e.dataset.al);
  });
}
function hasPaint() {
  if (!ready) return false;
  const d = lx.getImageData(0, 0, layer.width, layer.height).data;
  for (let i = 3; i < d.length; i += 4) if (d[i] > 8) return true;
  return false;
}
function syncSceneUI() {
  $$('#sceneSeg button').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.scene === scene)));
  CFG.t = scene === 'metro' ? Object.assign({}, T0, TMETRO) : T0;
  relabel();
  const ob = $('#otherBtn'), o = SCENES[scene === 'truck' ? 'metro' : 'truck'];
  if (ob && o && o.other) ob.textContent = o.other;
}
function loadScene(name) {
  const sc = SCENES[name]; if (!sc || !sc.cover) return;
  const im = new Image(); im.crossOrigin = 'anonymous';
  im.onload = () => {
    scene = name;
    undoStack.length = 0; drips.length = 0; $('#undo').disabled = true;
    prepare(im); S.hand = false; applyBase(); zoomFit(); syncTool(); syncMode(); dirty = true; render(); syncSceneUI();
  };
  im.onerror = () => toast('Non riesco a caricare la copertina.');
  im.src = sc.cover;
}
function trySwitch(name) {
  if (!ready || !SCENES_OK || name === scene || step !== 1 || editing) return;
  if (hasPaint()) { pendingScene = name; $('#sceneAsk').hidden = false; return; }
  loadScene(name);
}
$$('#sceneSeg button').forEach(b => b.addEventListener('click', () => trySwitch(b.dataset.scene)));
$('#sceneYes').addEventListener('click', () => { const n = pendingScene; pendingScene = null; $('#sceneAsk').hidden = true; if (n) loadScene(n); });
$('#sceneNo').addEventListener('click', () => { pendingScene = null; $('#sceneAsk').hidden = true; });
$('#otherBtn').addEventListener('click', () => { if (!SCENES_OK) return; goStep(1); loadScene(scene === 'truck' ? 'metro' : 'truck'); });
// when the metro cover comes from a file (not embedded) it is fetched quietly after the page has settled, so the first switch is instant
if (SCENES_OK && !/^data:/.test(SCENES.metro.cover) && !(navigator.connection && navigator.connection.saveData)) setTimeout(() => { const w = new Image(); w.crossOrigin = 'anonymous'; w.src = SCENES.metro.cover; }, 2500);
if (/[?&]gmtest\b/.test(location.search)) window.__scene = { get: () => scene, hasPaint, ok: SCENES_OK };

// ---------- boot ----------
const img = new Image();
img.onload = () => {
  prepare(img); syncTool(); syncMode(); render(); syncSceneUI();
  // theme editor only: show the final screen straight away so its texts and style can be edited without painting first
  if (CFG.preview && CFG.preview !== 'off') {
    goStep(2, true);
    const demo = 'nome@email.it';
    if (CFG.preview === 'sent') showSent(demo, true, false, true, false, true);
    else if (CFG.preview === 'ready') showSent(demo, false, false, false, false, true);
    else if (CFG.preview === 'error') showSent(demo, false, true, false, false, true);
  }
  undoMax = Math.max(6, Math.min(14, Math.floor(160e6 / (layer.width * layer.height * 4))));
  if (/[?&]gmtest\b/.test(location.search)) window.__game = { CX, CY, CW, CH, LS, V, W, H, BASE, peek: (x, y) => lx.getImageData(Math.round(x * LS), Math.round(y * LS), 1, 1).data[3], maskArea: maskCrop.reduce((a, b) => a + b, 0), layerW: layer.width, layerH: layer.height };
};
img.onerror = () => toast('Non riesco a caricare la copertina.');
img.crossOrigin = 'anonymous'; img.src = COVER;
['Permanent Marker', 'Rubik Spray Paint', 'Bungee'].forEach(f => { try { document.fonts.load(`48px "${f}"`, 'Aa'); } catch (_) {} });
syncTab();
requestAnimationFrame(frame);
}

function gmInit() {
  document.querySelectorAll('[data-gm-game]').forEach(h => { if (h.__gm) return; h.__gm = true; gmStart(h); });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', gmInit); else gmInit();
document.addEventListener('shopify:section:load', gmInit);
